// @flow

import EventNames from '../constants/EventNames';
import StatusCodes from '../constants/StatusCodes';
import User from './User';

export default class LivewireErrorHandler {
  /**
   * Start listening for failing Livewire requests
   */
  static register(): void {
    document.addEventListener(EventNames.LIVEWIRE_INIT, () => {
      Livewire.interceptRequest(({ onError, onFailure }: Object) => {
        onError(({ response, preventDefault }: Object) => {
          LivewireErrorHandler.handleErrorResponse(response, preventDefault);
        });

        onFailure(() => {
          User.notifyFail();
        });
      });
    });
  }

  /**
   * Handle a Livewire response the server could not fulfill
   */
  static handleErrorResponse(response: Response, preventDefault: () => void): void {
    if (LivewireErrorHandler.sessionHasExpired(response)) {
      preventDefault();
      window.location.reload();
      return;
    }

    if (!window.store.environment.isProduction()) {
      return;
    }

    preventDefault();
    User.notifyFail();
  }

  /**
   * A 419 only means an expired session when the server says so. Livewire also
   * answers with a 419 when it refuses a request, and that needs a message
   * instead of a silent reload.
   */
  static sessionHasExpired(response: Response): boolean {
    return response.status === StatusCodes.SESSION_EXPIRED &&
      !!response.headers.get('X-Session-Expired');
  }
}
